// extracted by mini-css-extract-plugin
module.exports =  {"footer":"footer--gJgF3","btn":"btn--VYYAM"};